import useSWR from 'swr';

import { fetcher } from '@/utils/swr-utils';
import { MODELS_PATH } from './paths';
import { IModelBasic } from '@/models/IModelBasic';

export default function useModels(params?: URLSearchParams) {
  let key = `${MODELS_PATH}?includeLatestRelease=true`;

  if (params?.toString() !== '') {
    const searchParams = new URLSearchParams(params);
    const status = searchParams.get('status');

    if (status) searchParams.set('status', status.toUpperCase());

    key += `&${searchParams.toString()}`;
  }

  const { data, error, isLoading } = useSWR<IModelBasic[]>(key, fetcher);

  return { models: data, isLoading, isError: Boolean(error) };
}
